import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  PoolId
} from './poolSlice'

import {GetAllPoolsState, GetAllUserPools} from "@/context/UserPoolsContext.tsx";
import {CurrentMonthUtc} from "@/common/types/api/other.types.api.ts";


export const loadAllData = createAsyncThunk(
  'pool/loadAllData',
  async (
    {
      currentMonthUtc,
      address,
      getAllPoolsState, getAllUserPools
    }: {
      currentMonthUtc: CurrentMonthUtc | undefined
      address: string | undefined
      getAllPoolsState: GetAllPoolsState
      getAllUserPools: GetAllUserPools
    },
    {rejectWithValue}
  ) => {
    try {
      const poolData =  await getAllPoolsState()
      const userData = address ? await getAllUserPools(address) : null
      const poolId = currentMonthUtc ? {
        year: currentMonthUtc.year,
        month: currentMonthUtc.month
      } as PoolId : null

      const addr  = address ? address as string : null

      return {poolData, userData, poolId, addr}
    } catch (error) {
      console.error('Error loadAllData',error)
      return rejectWithValue('Ошибка загрузки пула или пользователя')
    }
  }
)